import { z } from "zod";

/**
 * Zod schema for POST /jobs/:id/engagement-open request body.
 * lat, lng, and accuracyM are all optional numbers.
 */
export const EngagementOpen = z.object({
  lat: z.number().optional(),
  lng: z.number().optional(),
  accuracyM: z.number().optional(),
});

export type EngagementOpen = z.infer<typeof EngagementOpen>;

/**
 * Zod schema for wire Engagement row with joined labels for office map.
 */
export const Engagement = z.object({
  id: z.string().uuid(),
  tenantId: z.string().uuid(),
  propertyId: z.string().uuid(),
  openedByJobId: z.string().uuid(),
  lat: z.number().nullable(),
  lng: z.number().nullable(),
  accuracyM: z.number().nullable(),
  openedAt: z.string(),
  closedAt: z.string().nullable(),
  closedByJobId: z.string().uuid().nullable(),
  // Joined presentation labels
  jobNumber: z.string().optional(),
  propertySiteName: z.string().optional(),
  driverName: z.string().optional(),
});

export type Engagement = z.infer<typeof Engagement>;
